import { useCallback, useEffect, useState } from 'react';
import collectionApi, { Meta } from '../../../../services/collectionApi';
import { CollectionPolicy, CollectionRule, newId } from './collectionModel';

export const withRuleIds = (policy: CollectionPolicy): CollectionPolicy => ({
    ...policy,
    schedules: { preventive: policy.schedules?.preventive ?? null, overdue: policy.schedules?.overdue ?? null },
    rules: (policy.rules || []).map((rule): CollectionRule => ({ ...rule, id: rule.id || newId('rule') })),
});

const useCollectionSettings = () => {
    const [policies, setPolicies] = useState<CollectionPolicy[]>([]);
    const [meta, setMeta] = useState<Meta>({});
    const [loading, setLoading] = useState(true);
    const [failed, setFailed] = useState(false);
    const [version, setVersion] = useState(0);

    useEffect(() => {
        let active = true;
        setLoading(true);
        setFailed(false);
        collectionApi.listPolicies({ size: 500 })
            .then(policyPage => {
                if (!active) return;
                setPolicies((policyPage.data || []).map(withRuleIds));
                setMeta(policyPage.meta || {});
            })
            .catch(() => { if (active) setFailed(true); })
            .finally(() => { if (active) setLoading(false); });
        return () => { active = false; };
    }, [version]);

    const reload = useCallback(() => setVersion(v => v + 1), []);

    return { policies, meta, loading, failed, reload };
};

export default useCollectionSettings;
